module.exports = __webpack_public_path__ + "img/connection-1.de3154f9.svg";